module.exports = __webpack_public_path__ + "static/img/tool-2.aebac2f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tool-2.png
// module id = UNaq
// module chunks = 1